module.exports = __webpack_public_path__ + "img/expenditureItemIcon2.2db7fcf8.png";